<script setup>
import AgeList from "@/components/main/recordVideo/age/ageList.vue";
import {computed,  ref} from "vue";
import {useComStore, useLanguageStore} from "@/pinia";
const languageStore = useLanguageStore();
const codes = ref([]);
const comStore =useComStore();

const props = defineProps(['menu', 'ages']);
const age = ref('');
const emits = defineEmits(['set_age'])
const set_age = (a)=>{
  age.value = a
  emits('set_age' , a)
}

const getCodeNm = computed(()=>{
  if(props.menu =='mt000' ){
    return languageStore.get('recentMeetings')
  } else{
    return comStore.getCommonNm(props.menu)
  }
})
</script>

<template>
  <div class="ageListArea">
    <div class="meetingTitle">
      {{getCodeNm}}
    </div>
    <AgeList :ages="ages" @set_age="set_age"></AgeList>
  </div>
</template>

<style scoped>
  .ageListArea{
    width: 15vw;
    margin-left: 20px;
    top: 10px;
  }
  .meetingTitle{
    font-size: 1.2rem;
    font-weight: bold;
    color: white;
    width: 100%;
    height: 10vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #09223F;
  }
</style>